module.exports = __webpack_public_path__ + "media/images/flags/mr-3642790a35ff100e55f7874d13af32c5.svg";